import {
    FinalCounterpartyType,
    RequisiteAgreementType,
    RequisiteName,
    RequisiteRole,
    RequisitesFieldName,
    RequisitesFormName,
} from 'utils/constants/requisites';

import { INITIAL_REQUISITES, Requisites, RequisitesForm } from 'store/models/requisites';

export type PrimaryAgencyRequisitesInRequest = Omit<
    Requisites,
    RequisiteName.AgreementDate | RequisiteName.AgreementId | RequisiteName.AgreementType
>;

export type AgencyRequisitesInRequest = Omit<Requisites, RequisiteName.AgreementType>;

export interface RequisitesData {
    isRequisitesEditable: boolean;
    [RequisitesFormName.FinalAdvertiserRequisites]: Requisites | null;
    [RequisitesFormName.AgencyRequisites]: AgencyRequisitesInRequest | null;
    [RequisitesFormName.PrimaryAgencyRequisites]: PrimaryAgencyRequisitesInRequest | null;
    [RequisitesFieldName.IsAgency]: boolean | null;
    [RequisitesFieldName.IsAgreementDirect]: boolean | null;
    [RequisitesFieldName.Consent]: boolean;
    [RequisitesFieldName.FinalCounterpartyType]: FinalCounterpartyType | null;
}

export type SaveRequisitesData = Omit<RequisitesData, 'isRequisitesEditable'>;

const convertRoleFromDto = (isAgency: boolean | null): RequisiteRole | null => {
    if (typeof isAgency !== 'boolean') return null;
    return isAgency ? RequisiteRole.Agency : RequisiteRole.FinalAdvertiser;
};

const convertAgreementFromDto = (isAgreementDirect: boolean | null): RequisiteAgreementType | null => {
    if (typeof isAgreementDirect !== 'boolean') return null;
    return isAgreementDirect ? RequisiteAgreementType.Direct : RequisiteAgreementType.NotDirect;
};

export const requisitesDataFromDto = (requisites: RequisitesData): RequisitesForm => {
    const { consent, finalAdvertiserRequisites, agencyRequisites, primaryAgencyRequisites, finalCounterpartyType } =
        requisites;
    return {
        [RequisitesFormName.FinalAdvertiserRequisites]:
            finalAdvertiserRequisites || INITIAL_REQUISITES[RequisitesFormName.FinalAdvertiserRequisites],
        [RequisitesFormName.AgencyRequisites]: agencyRequisites || null,
        [RequisitesFormName.PrimaryAgencyRequisites]: primaryAgencyRequisites ? { ...primaryAgencyRequisites } : null,
        [RequisitesFieldName.IsAgency]: convertRoleFromDto(requisites.isAgency),
        [RequisitesFieldName.IsAgreementDirect]: convertAgreementFromDto(requisites.isAgreementDirect),
        [RequisitesFieldName.Consent]: consent,
        [RequisitesFieldName.FinalCounterpartyType]: finalCounterpartyType,
    };
};

export const requisitesFormToDto = (requisites: RequisitesForm): SaveRequisitesData => {
    const {
        consent,
        finalAdvertiserRequisites,
        agencyRequisites,
        primaryAgencyRequisites,
        isAgency,
        isAgreementDirect,
        finalCounterpartyType,
    } = requisites;
    return {
        [RequisitesFormName.FinalAdvertiserRequisites]: finalAdvertiserRequisites || INITIAL_REQUISITES,
        [RequisitesFormName.AgencyRequisites]: agencyRequisites || null,
        [RequisitesFormName.PrimaryAgencyRequisites]: primaryAgencyRequisites || null,
        [RequisitesFieldName.IsAgency]: isAgency !== null ? isAgency === RequisiteRole.Agency : isAgency,
        [RequisitesFieldName.IsAgreementDirect]:
            isAgreementDirect !== null ? isAgreementDirect === RequisiteAgreementType.Direct : isAgreementDirect,
        [RequisitesFieldName.Consent]: consent,
        [RequisitesFieldName.FinalCounterpartyType]: finalCounterpartyType,
    };
};
